export const selectLanguage = (state) => state.languageReducer.language